import { render, staticRenderFns } from "./CollegeUserLoginRegister.vue?vue&type=template&id=42e4d525&scoped=true&"
import script from "./CollegeUserLoginRegister.vue?vue&type=script&lang=js&"
export * from "./CollegeUserLoginRegister.vue?vue&type=script&lang=js&"
import style0 from "./CollegeUserLoginRegister.vue?vue&type=style&index=0&id=42e4d525&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4d525",
  null
  
)

export default component.exports